// extracted by mini-css-extract-plugin
export default {"cell":"selectableColumn_cell__7uIfO","selectCheckBox":"selectableColumn_selectCheckBox__Rh02b"};